/**
 * @fileoverview Body Parts theme - match body part emojis (educational).
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Body Parts theme for learning anatomy basics.
 */
export class BodyPartsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'body_parts',
            'Body Parts',
            allLabels.bodyParts,
            { numPairs: 3, isPremium: false, hasMovement: false, ...options }
        );
    }
}
